import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import i18n from "../i18n";
import Mammoth from "mammoth";
import { getCountry } from "../lib/middleware";

export default function TermsConditions() {
    const { t } = useTranslation();
    const [termsContent, setTermsContent] = useState<string>("");

    useEffect(() => {
        async function loadTerms() {
            const currentLanguage = i18n.language; // Get the latest language
            try {
                const country = getCountry();
                let docxFile =
                    currentLanguage === "en" ? "/UAE-en.docx" : "/UAE-ar.docx";

                if (country === "uae") {
                    docxFile =
                        currentLanguage === "en"
                            ? "/UAE-en.docx"
                            : "/UAE-ar.docx";
                } else if (country === "saudi") {
                    docxFile =
                        currentLanguage === "en"
                            ? "/KSA-en.docx"
                            : "/KSA-ar.docx";
                }

                const response = await fetch(docxFile);
                const arrayBuffer = await response.arrayBuffer();
                const { value } = await Mammoth.extractRawText({ arrayBuffer });

                setTermsContent(value);
            } catch (error) {
                console.error("Error loading Terms & Conditions:", error);
                setTermsContent("Failed to load content.");
            }
        }

        loadTerms();

        // Listen for language changes and reload terms
        const handleLanguageChange = () => loadTerms();
        i18n.on("languageChanged", handleLanguageChange);

        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);

    return (
        <div className="mx-auto flex max-w-[885px] flex-col items-center gap-10 px-4 py-[60px]">
            <h1 className="text-[28px] font-medium text-[rgba(23,23,23,1)]">
                {t("terms-and-conditions")}
            </h1>
            <div className="whitespace-pre-line text-[16px] text-[rgba(23,23,23,1)]">
                {termsContent || "Loading..."}
            </div>
        </div>
    );
}
